<template>
  <div class="telegram-bot-linked">
    <SuccessIcon class="telegram-bot-linked__icon" />
    <p class="telegram-bot-linked__title">Telegram-бот підключено</p>
    <p class="telegram-bot-linked__username" v-if="username">@{{ username }}</p>
    <p class="telegram-bot-linked__hint">
      Щоб відвʼязати бота, надішліть команду <code>/unlink</code> у чаті з ботом.
    </p>
  </div>
</template>

<script>
import { SuccessIcon } from '@/shared/ui/icons';

export default {
  components: { SuccessIcon },
  props: {
    username: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.telegram-bot-linked {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  margin: 0 auto;

  &__icon {
    transform: scale(3);
    margin-bottom: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #09090B;
    margin-bottom: 8px;
  }

  &__username {
    font-size: 14px;
    color: #6171E4;
    margin-bottom: 16px;
  }

  &__hint {
    font-size: 14px;
    color: #71717A;

    code {
      background: #F6F6F9;
      border-radius: 4px;
      padding: 2px 6px;
    }
  }
}
</style>
